export default __webpack_public_path__ + "static/media/gq.183a7f0a.svg";